module.exports = "/images/sala_viajero_pv02.jpg?dc9f32ecd488349101a65f22c91a70ef";